import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@-/dev.improve.haniverse.components.ui.dropdown-menu";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { ChoiceMenuProps } from "#choice-menu-props";

/**
 * A one-of-many choice on Android and web, drawn by the shared JS dropdown's radio rows. iOS uses
 * the system (SwiftUI) menu instead (`choice-menu.ios.tsx`).
 */
export function ChoiceMenu<Value extends string>({
  align,
  contentClassName,
  disabled,
  onValueChange,
  options,
  side,
  sideOffset,
  trigger,
  triggerNativeID,
  value,
}: ChoiceMenuProps<Value>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled} nativeID={triggerNativeID}>
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        className={contentClassName}
        side={side}
        sideOffset={sideOffset}
      >
        <DropdownMenuRadioGroup
          onValueChange={(next) => {
            const option = options.find((candidate) => candidate.value === next);
            if (option !== undefined) {
              onValueChange(option.value);
            }
          }}
          value={value}
        >
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} testID={option.testID} value={option.value}>
              <Text>{option.label}</Text>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
